export function valueToLocaleString(value) {
  if (!value) return '';

  return `$${Math.floor(value).toLocaleString()}`;
}
